<template>
  <div class="container-custom">
    <!-- breadcrumbs -->
    <div class="breadscrumbs">
      <a class="breadscrumbs-item active">Products</a>
    </div>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>Products</h2>
      <v-spacer></v-spacer>
      <div class="button-segmented relative">
        <button class="btn btn-primary" @click="toProductCreate">
          <v-icon :style="{ fontSize: '20px' }" color="white" class="mr-2"
            >add</v-icon
          >
          <span>新增商品</span>
        </button>
        <button
          class="btn btn-primary pa-0"
          @click="isAddNewButtonShow = !isAddNewButtonShow"
        >
          <v-icon :style="{ fontSize: '20px' }" color="white"
            >arrow_drop_down</v-icon
          >
        </button>
        <div
          v-if="isAddNewButtonShow"
          class="button-segmented-menu  absolute"
          style="top: 40px; z-index: 1;"
        >
          <div class="elevation-6 white">
            <div class="option" @click="toProductCreate">新增單筆資料</div>
            <div class="option" @click="isUplodFilesDialogOpen = true">
              批次匯入CSV
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Dialog -->
    <ProductListDialog
      :isUplodFilesDialogOpen.sync="isUplodFilesDialogOpen"
    ></ProductListDialog>
    <!-- Table -->
    <ProductTable></ProductTable>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ProductListDialog from '@/views/C-3__Products/c/C-3e-1__ProductList_Dialog-with-DropZone.vue';
import ProductTable from '@/views/C-3__Products/c/ProductTable.vue';

export default {
  components: {
    ProductListDialog,
    ProductTable,
  },
  data: () => ({
    isAddNewButtonShow: false,
    isUplodFilesDialogOpen: false,
  }),
  created() {
    this.clear();
    this.getProducts();
  },
  methods: {
    ...mapActions('product', {
      getProducts: 'find',
      clear: 'clear',
    }),
    toProductCreate() {
      this.$router.push({ name: 'ProductCreate' });
    },
  },
};
</script>

<style></style>
